import { appEnv } from '@/config/env';
import { User } from '@auth0/auth0-react';

type GetAccessTokenSilently = (options?: {
  authorizationParams?: { audience?: string };
}) => Promise<string>;

class Auth0Client {
  private static instance: Auth0Client;
  private getAccessTokenSilentlyFn?: GetAccessTokenSilently;
  private user?: User;

  private constructor() {}

  public static getInstance(): Auth0Client {
    if (!Auth0Client.instance) {
      Auth0Client.instance = new Auth0Client();
    }
    return Auth0Client.instance;
  }

  public initialize(
    getAccessTokenSilently: GetAccessTokenSilently,
    user?: User,
  ) {
    this.getAccessTokenSilentlyFn = getAccessTokenSilently;
    this.user = user;
  }

  public async getAccessToken(): Promise<string> {
    if (!this.getAccessTokenSilentlyFn) {
      throw new Error('Auth0Client not initialized. Call initialize() first.');
    }
    return await this.getAccessTokenSilentlyFn({
      authorizationParams: {
        audience: appEnv.auth0.audience,
      },
    });
  }

  public getUserEmail(): string {
    if (!this.user) {
      throw new Error('Auth0Client not initialized');
    }
    return this.user.email || '';
  }
}

export default Auth0Client;
